module.exports = __webpack_public_path__ + "static/img/grid-20px-500x500.7a4bc2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static_dazzle/images/template/grid-20px-500x500.png
// module id = EtcZ
// module chunks = 1